import { render, staticRenderFns } from "./PsiBreadcrumbButtons.vue?vue&type=template&id=17c83ebe"
import script from "./PsiBreadcrumbButtons.vue?vue&type=script&lang=js"
export * from "./PsiBreadcrumbButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports